import { initDocument } from "@src/config/init";
import { openTransactionModal } from "@src/services";
import { createTxWidgetWC, TxWidgetWCWrapped } from "./components";

const TxWidgetWC = createTxWidgetWC();

initDocument();

export * from "@src/models";
export { openTransactionModal } from "@src/services";
export { TxWidgetWCWrapped as TxWidget } from "./components";
export { TxWidgetWC };

const XPay = {
  openTransactionModal,
  TxWidget: TxWidgetWCWrapped,
  TxWidgetWC,
};

export default XPay;
